import { GenericAbortSignal } from "axios";
import { AutoCompleteDataModel, AutoCompleteSuggestions, MprcAutoComplete } from "components/MprcAutoComplete";
import { IAutoCompleteProps } from "components/MprcAutoComplete/AutoComplete";
import { PublicationSelectorOrder, PublicationSelectorType } from "generated/CoreApi_v1";
import { isCanceledError, useCoreApi } from "providers/CoreApiProvider";

////////////////////////////////////////////////////////////////////////////

interface IProps extends Omit<IAutoCompleteProps, 'onGetSuggestions' | "emptyThumbnail"> {
    selectorType?: PublicationSelectorType;
}

////////////////////////////////////////////////////////////////////////////

/**
 * Auto complete de publicações
 * @param props
 */
export const PublicationAutoComplete: React.FC<IProps> = (props) => {

    const api = useCoreApi();

    ///
    const getSuggestions = (searchText: string, pageNumber: number, pageSize: number, trySelectedHistory: boolean, signal: GenericAbortSignal | undefined): Promise<AutoCompleteSuggestions<AutoCompleteDataModel>> => {
        searchText = searchText.toLowerCase();

        return new Promise<AutoCompleteSuggestions<AutoCompleteDataModel>>((resolve) => {
            api.v1.knowledgeSelectors.publications({
                searchText: searchText,
                pageNumber: pageNumber,
                pageSize: pageSize,
                selectorType: props.selectorType ?? PublicationSelectorType.Any,
                orderBy: PublicationSelectorOrder.Title,
                listPublicationId: null,
                onlyPostPublications: false,
                userId: null
            }, { signal })
                .then(result => {
                    resolve({
                        items: result.data.items.map(i => ({ key: i.publicationId, label: i.title } as AutoCompleteDataModel)),
                        totalRows: result.data.totalRows
                    });
                })
                .catch(error => {
                    if (!isCanceledError(error)) {
                        resolve({ items: [], totalRows: 0 });
                        if (props.onError) props.onError(props.error);
                    }
                });
        });
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <MprcAutoComplete
            {...props}
            onGetSuggestions={getSuggestions}
        />
    );
};
